import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    /**
     * Get company of current user
     * @returns {Promise} response.data (company object)
     */
    async getCompany() {
        const response = await axios.get(
            API_URL + "/company", 
            { headers: authHeader() }
        );
        return response.data;
    },

    /**
     * Update company of current user
     * @param {Object} companyData - { name, city, address, pin }
     * @returns {Promise} response.data
     */
    async updateCompany(companyData) {
        const response = await axios.put(
            API_URL + "/company", 
            companyData, 
            { headers: authHeader() }
        );
        return response.data;
    },
};